export default __webpack_public_path__ + "static/media/IMG_4901.bea3ee02.png";